import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Table } from '../../../../../../common/table'
import { TextEllipsisStaticLine } from '../../../../../../common/textEllipsis/TextEllipsisStaticLine'
import { valToPercent } from '../../../../../../helpers/value'
import { SORT_DIRECTION } from '../../../../../../utils/common'
import { HeaderTable } from '../../HeaderTable'
import { getHeadersFollowColumn } from '../../helpers'
import {
  selectGrowRateHeaders,
  selectGrowRateItem,
  selectIds,
  selectIsLoading,
  selectSortTable,
  sort,
} from '../store/slice'

export const ImportExportGrowthRateTable = ({ isDynamicReport, column }) => {
  const dispatch = useDispatch()

  const ids = useSelector(selectIds)
  const isLoading = useSelector(selectIsLoading)
  const headers = useSelector(selectGrowRateHeaders)
  const sortTable = useSelector(selectSortTable)

  const customHeaders = isDynamicReport
    ? getHeadersFollowColumn(headers, column)
    : headers

  const changeSort = (data) => {
    dispatch(sort({ sortTable: data, type: 'growRateData' }))
  }

  useEffect(() => {
    if (ids.length && !!headers.length) {
      dispatch(
        sort({
          sortTable: {
            sortBy: [...headers].reverse()[0].childCol[0].colId,
            sortDirection: SORT_DIRECTION.DESC,
          },
          type: 'valueData',
        }),
      )
    }
  }, [ids.length])

  return (
    <Table
      ids={ids}
      isLoading={isLoading}
      isNoDataWithHead={!isDynamicReport}
      isDisplayScroll={!isDynamicReport}
      isNoStickyHead={isDynamicReport}
      isStickyFirstCol={!isDynamicReport}
      getDataFromRedux={selectGrowRateItem}
      renderTHead={() => (
        <HeaderTable
          isDynamicReport={isDynamicReport}
          headerTable={customHeaders}
          sort={sortTable}
          changeSort={changeSort}
        />
      )}
      schema={customHeaders
        .map((item, index) => {
          if (index === 0) {
            return {
              ...item,
              render: (val) => {
                return isDynamicReport ? (
                  val
                ) : (
                  <TextEllipsisStaticLine
                    isI18n={false}
                    text={val}
                    lineClamp={2}
                    appendStyle={{ width: 350 }}
                  />
                )
              },
            }
          }

          if (item.childCol) {
            return item.childCol.map((childItem) => {
              return {
                ...childItem,
                render: (val, { locale }) => {
                  return valToPercent(val, locale)
                },
              }
            })
          }

          return item
        })
        .flat()}
    />
  )
}
